export default {
  actionCloseText: 'Click here to expand filter',
}
